import React from "react";
import { Modal } from "antd";
import { useTheme } from "styled-components";
import { useHistory, useLocation } from "react-router-dom";
/*
 * Customizable template that's barebones (no headers, footers, etc.)
 * Here the children do all the work to fill out content
 */
const ModalLayout = props => {
  const history = useHistory();
  const location = useLocation();
  const theme = useTheme();
  const bgpath = location.state?.background;
  const preventClose = !!location.state?.subscriptionPath;
  return (
    <Modal
      visible={true}
      zIndex={theme.zIndex.modal}
      onCancel={
        preventClose
          ? undefined
          : () => (bgpath ? history.push(bgpath) : history.push("/"))
      }
      closable={!preventClose}
      maskClosable={!preventClose}
      footer={null}
      centered
      destroyOnClose
      width={560}
    >
      {props.children}
    </Modal>
  );
};

export default ModalLayout;
